import makeStyles from '@mui/styles/makeStyles';
import { Theme } from '@mui/material/styles';

export const useHeaderMenuStyles = makeStyles(
  (theme: Theme) => {
    return {
      container: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',

        backgroundColor: theme.palette?.mode === 'dark' ? '#383838' : '#F7F8F8',
        borderRadius: '.5rem',
        border:
          theme.palette?.mode === 'dark'
            ? '1px solid #616161'
            : '1px solid #E1E3E5',
      },
      button: {
        display: 'flex',
        justifyContent: 'flex-start',
        color: theme.palette?.mode === 'dark' ? '#fff' : '#333333',
        textTransform: 'none',
        border: 'none',
        padding: '1rem',
        gap: '.75rem',

        '&:hover': {
          backgroundColor:
            theme.palette?.mode === 'dark' ? '#4D4D4D' : '#E9EBEC',
        },
        '& .v5-MuiSvgIcon-root': {
          color: theme.palette?.mode === 'dark' ? '#B6B5B6' : '#9D9EA6',
        },
        '& .v5-MuiButton-startIcon': {
          margin: '0',
        },
        '& .buttonContent': {
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
          justifyContent: 'center',
          width: '160px',
          textAlign: 'justify',
          gap: '.25rem',
          '& .buttonTitle': {
            color: theme.palette?.mode === 'dark' ? '#B6B5B6' : '#35363A',
            fontSize: '14px',
            lineHeight: '16px',
          },
          '& .buttonSubtitle': {
            color: theme.palette?.mode === 'dark' ? '#B6B5B6' : '#74757E',
            fontSize: '12px',
            lineHeight: '16px',
          },
        },
      },
    };
  },
  { name: 'HeaderMenu' },
);
